// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useRef, useState, useMemo, CSSProperties, useEffect, useContext } from 'react';
import styled from 'styled-components';
import LeaderBoardNotion from './LeaderBoardNotion';
import { FormattedMessage } from 'react-intl';
import MemberContext from '../../../contexts/MemberContext';
import RewardIconFirst from '../../../assets/images/ChallengeRankFirst.svg';
import RewardIconSecond from '../../../assets/images/ChallengeRankSecond.svg';
import RewardIconThird from '../../../assets/images/ChallengeRankThird.svg';
import { getChallengeRank } from '../../../apis/challenge';
import { useParamsId } from '../../../lib/utility';
import LoadingIcon from '../../../components/LoadingIcon';

const S = {
  LeaderBoard: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  Bulletin: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background: #FFFBF0;
    border-radius: 4px;
    width: 591px;
  `,
  Title: styled.div`
    display: flex;
    justify-content: center;
    line-height: 35px;
    font-weight: 700;
    font-size: 24px;
    color: #EF8200;
  `,
  ButtonFrame: styled.div`
    display: flex;
    position: relative;
    justify-content: center;
  `,
  SwitchButton: styled.div`
    display: flex;
    justify-content: center;
    font-weight: 700;
    font-size: 16px
    line-height: 23px;
    color: #EF8200;
    margin: 21px;
  `,
  AttFrame: styled.div`
    display: flex;
    margin-top: 4px;
  `,
  Rank: styled.div`
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 200%;
    color: #434343;
    width: 33px;
    margin-left: 47px;
    flex-direction: row-reverse;
  `,
  Name: styled.div<{ isHintOn: boolean }>`
  ${props => {
    switch (props.isHintOn) {
      case true:
        return 'margin-right: 191px;'
      case false:
        return 'margin-right: 296px;'
    }
  }};
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 200%;
    color: #434343;
    width: 39px;
    margin-left: 25px;
  `,
  Time: styled.div<{ isHintOn: boolean }>`
  ${props => {
    switch (props.isHintOn) {
      case true:
        return 'width: 113px;'
      case false:
        return 'width: 113px;'
    }
  }};
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 200%;
    color: #434343;
    justify-content: center;
  `,
  HintOpen: styled.div`
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 200%;
    color: #434343;
    width: 67px;
    margin-right: 38px;
    justify-content: center;
  `,
  Tab: styled.div<{ isHintOn: boolean }>`
    display: flex;
    justify-content: center;
    font-size: 16px;
    line-height: 23px;
    font-weight: ${props => props.isHintOn ? 400 : 700};
    color: ${props => props.isHintOn ? '#848484;' : '#EF8200;'};
    margin-top: 19px;
    margin-bottom: 3px;
    cursor: pointer;
    width: 124px;
  `,
  TabLine: styled.div`
    position: absolute;
    left: 0;
    bottom: 0;
    height: 3px;
    background-color: #EF8200;
    width: 124px;
    transition: 0.3s;
  `,
  RankFrame: styled.div<{ isUserOnRank?: boolean, Rank: number }>`
  ${props => {
    if (props.isUserOnRank && props.Rank <= 3) {
      return 'border: 2px solid #FE4747; border-radius: 4px; margin: 0px;'
    } else if (props.isUserOnRank && props.Rank > 3) {
      return 'border: 2px solid #EF8200; border-radius: 4px; margin: 0px;'
    } else {
      return 'margin: 3px;'
    }
  }};
    display: flex;
  `,
  RankItem: styled.div<{ Rank: number }>`
  ${props => {
    switch (props.Rank) {
      case 1:
        return 'background: #FDB258;'
      case 2:
        return 'background: #FFDB87;'
      case 3:
        return 'background: #FFEEC5;'
      default:
        return 'background: #FFFBF0;'
    }
  }};
  ${props => (props.Rank <= 3) ? 'box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25)' : null}};
    width: 591px;
    height: 51px;
    display: flex;
    align-items: center;
    border-radius: 4px;
  `,
  itemRank: styled.div<{ Rank: number, isUserOnRank?: boolean }>`
  ${props => (props.Rank <= 3) ? 'font-size: 24px; width: 13px; margin-left: 17px;' : 'font-size: 18px; width: 68px;'};
  ${props => {
    switch (props.Rank) {
      case 1:
        return 'color: #FFF506;'
      case 2:
        return 'color: #A6A6A6;'
      case 3:
        return 'color: #FF8744;'
    }
    if (props.isUserOnRank && props.Rank > 3) {
      return 'color: #EF8200;'
    } else {
      return 'color: #434343;'
    }
  }};
    display: flex;
    line-height: 200%;
    flex-direction: row-reverse;
    font-weight: 700;
    align-items: center;
  `,
  itemName: styled.div<{ isHintOn: boolean, Rank: number, isUserOnRank?: boolean }>`
  ${props => props.isHintOn ? 'width: 242px;' : 'width: 335px;'}};
  ${props => (props.Rank <= 3) ? 'margin-left: 30px;' : 'margin-left: 33px;'};
  ${props => {
    if (props.Rank <= 3 && props.isUserOnRank) {
      return 'font-weight: 700; font-size: 20px; color: #434343;'
    } else if (props.Rank > 3 && props.isUserOnRank) {
      return 'color: #EF8200;'
    } else {
      return 'font-weight: 400; font-size: 18px; color: #313131;'
    }
  }};
    display: flex;
    line-height: 200%;
    align-items: center;
  `,
  itemHintOpen: styled.div<{ isUserOnRank?: boolean, Rank: number }>`
  ${props => {
    if (props.isUserOnRank && props.Rank <= 3) {
      return 'font-weight: 700; font-size: 18px; color: #434343;'
    } else if (props.isUserOnRank && props.Rank > 3) {
      return 'font-weight: 400; font-size: 18px; color: #EF8200;'
    } else {
      return 'font-weight: 400; font-size: 18px; color: #313131;'
    }
  }};
    display: flex;
    width: 10px;
    justify-content: center;
    margin-left: 20px;
    align-items: center;
  `,
  itemTime: styled.div<{ isHintOn: boolean, Rank: number, isUserOnRank?: boolean }>`
  ${props => props.isHintOn ? 'margin-left: 76px;' : 'margin-left: 13px;'};
  ${props => {
    if (props.Rank <= 3 && props.isUserOnRank) {
      return 'font-weight: 700; font-size: 18px; color: #434343;'
    } else if (props.Rank > 3 && props.isUserOnRank) {
      return 'font-weight: 400; font-size: 18px; color: #EF8200;'
    } else {
      return 'font-weight: 400; font-size: 18px; color: #313131;'
    }
  }};
    display: flex;
    line-height: 200%;
    width: 87px;
    justify-content: center;
    align-items: center;
  `,
  RewardIcon: styled.img.attrs<{ Rank?: number }>((props) => (props.Rank && { src: RewardIconSwitch(props.Rank)}))<{ Rank?: number }>`
    display: flex;
    margin-left: 13px;
    justify-content: flex-start;
    width: 29px;
    height: 34.1px;
    top: 131px;
    left: 13px;
  `,
  IconFrame: styled.div`
    display: flex;
    justify-content: center;
  `,
  PersonalRankBoard: styled.div`
    display: flex;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
    width: 663px;
    height: 126px;
    margin-bottom: 56px;
    justify-content: center;
    flex-direction: column;
  `,
  PersonalRankBoardTitle: styled.div`
    display: flex;
    justify-content: center;
    margin-top: 15px;
  `,
  TimeTitle: styled.div`
    display: flex;
    width: 129px;
    height: 23px;
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    color: #434343;
  `,
  RankTitle: styled.div`
    display: flex;
    font-weight: 400;
    font-size: 16px;
    width: 110px;
    height: 23px;
    line-height: 23px;
    color: #434343;
    margin-left: 77px;
  `,
  HintTitle: styled.div`
    display: flex;
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    width: 76px;
    height: 23px;
    margin-left: 102px;
    color: #434343;
  `,
  PersonalRankBoardItem: styled.div`
    display: flex;
  `,
  PersonalTime: styled.div`
    display: flex;
    font-weight: 700;
    font-size: 24px;
    line-height: 200%;
    color: #666666;
    width: 123px;
    height: 48px;
    margin-left: 74px;
    justify-content: center;
    margin-top: 15px;
  `,
  PersonalRank: styled.div`
    display: flex;
    font-weight: 700;
    font-size: 64px;
    line-height: 93px;
    text-align: center;
    color: #EF8200;
    width: 76px;
    height: 93px;
    margin-left: 101px;
    justify-content: center;
  `,
  PersonalHint: styled.div`
    display: flex;
    font-weight: 700;
    font-size: 24px;
    line-height: 200%;
    color: #666666;
    width: 15px;
    height: 35px;
    margin-left: 155px;
    margin-top: 15px;
    justify-content: center;
  `,
  NoRankMessage: styled.div`
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 200%;
    color: #434343;
    justify-content: center;
  `
}

function useTabLine(tabs: string[], currentTab: string): [React.RefObject<HTMLDivElement>, CSSProperties | undefined] {
  const tabLine = useRef<HTMLDivElement>(null);

  const tabLineStyle = useMemo<CSSProperties | undefined>(() => {
    if (!tabLine.current || !tabLine.current.parentElement) return

    const index = tabs.indexOf(currentTab);
    const containerLeft = tabLine.current.parentElement.getBoundingClientRect().left;
    const { left, width } = tabLine.current.parentElement.children[index].getBoundingClientRect()

    return {
      left: (left - containerLeft) + 'px',
      width: width + 'px',
    }
  }, [tabLine.current, currentTab]);

  return [tabLine as React.RefObject<HTMLDivElement>, tabLineStyle];
}

const RewardIconSwitch = (Rank: number) => {
  switch (Rank) {
    case 1:
      return RewardIconFirst
    case 2:
      return RewardIconSecond
    case 3:
      return RewardIconThird
    default:
      break
  }
}

const LeaderBoardItem = (props: any):JSX.Element => {
  const member = props.member;
  const isHintOn = props.isHintOn;
  const list = props.item;

  if (isHintOn) {
    const rankingListWithHint = list.map((item: any) => {
      if (item.userId == member.id) {
        return (
          <S.RankFrame key={item.rank} isUserOnRank={true} Rank={item.rank}>
            <S.RankItem Rank={item.rank}>
              {item.rank<=3 && <S.RewardIcon Rank={item.rank}></S.RewardIcon>}
              <S.itemRank Rank={item.rank} isUserOnRank={true}>{item.rank}</S.itemRank>
              {/* {item.userName!='' ? <S.itemName isHintOn={isHintOn} Rank={item.rank} isUserOnRank={true}>{item.email}</S.itemName> : <S.itemName isHintOn={isHintOn} Rank={item.rank} isUserOnRank={true}>userID-{item.userId}</S.itemName>} */}
              <S.itemName isHintOn={isHintOn} Rank={item.rank} isUserOnRank={true}>{item.email}</S.itemName>
              <S.itemHintOpen isUserOnRank={true} Rank={item.rank}>{item.hintOpen} </S.itemHintOpen>
              <S.itemTime isHintOn={isHintOn} isUserOnRank={true} Rank={item.rank}>{item.time}</S.itemTime>
            </S.RankItem>
          </S.RankFrame>
        )
      } else {
        return (
          <S.RankFrame key={item.rank} Rank={item.rank}>
            <S.RankItem Rank={item.rank}>
              {item.rank<=3 && <S.RewardIcon Rank={item.rank}></S.RewardIcon>}
              <S.itemRank Rank={item.rank}>{item.rank}</S.itemRank>
              {/* {item.userName!='' ? <S.itemName isHintOn={isHintOn} Rank={item.rank}>{item.email}</S.itemName> : <S.itemName isHintOn={isHintOn} Rank={item.rank}>userID-{item.userId}</S.itemName>} */}
              <S.itemName isHintOn={isHintOn} Rank={item.rank}>{item.email}</S.itemName>
              <S.itemHintOpen Rank={item.rank}>{item.hintOpen}</S.itemHintOpen>
              <S.itemTime isHintOn={isHintOn} Rank={item.rank}>{item.time}</S.itemTime>
            </S.RankItem>
          </S.RankFrame>
        )
      }
    })
    return (rankingListWithHint)
  } else {
    const rankingListWithoutHint = list.map((item: any) => {
      if (item.userId == member.id) {
        return (
          <S.RankFrame key={item.rank} isUserOnRank={true} Rank={item.rank}>
            <S.RankItem Rank={item.rank}>
              {item.rank<=3 && <S.RewardIcon Rank={item.rank}></S.RewardIcon>}
              <S.itemRank Rank={item.rank} isUserOnRank={true}>{item.rank}</S.itemRank>
              {/* {item.userName!='' ? <S.itemName isHintOn={isHintOn} Rank={item.rank} isUserOnRank={true}>{item.email}</S.itemName> : <S.itemName isHintOn={isHintOn} Rank={item.rank} isUserOnRank={true}>userID-{item.userId}</S.itemName>} */}
              <S.itemName isHintOn={isHintOn} Rank={item.rank} isUserOnRank={true}>{item.email}</S.itemName>
              <S.itemTime isHintOn={isHintOn} isUserOnRank={true} Rank={item.rank}>{item.time}</S.itemTime>
            </S.RankItem>
          </S.RankFrame>
        )
      } else {
        return (
          <S.RankFrame key={item.rank} Rank={item.rank}>
            <S.RankItem Rank={item.rank}>
              {item.rank<=3 && <S.RewardIcon Rank={item.rank}></S.RewardIcon>}
              <S.itemRank Rank={item.rank}>{item.rank}</S.itemRank>
              {/* {item.userName!='' ? <S.itemName isHintOn={isHintOn} Rank={item.rank}>{item.email}</S.itemName> : <S.itemName isHintOn={isHintOn} Rank={item.rank}>userID-{item.userId}</S.itemName>} */}
              <S.itemName isHintOn={isHintOn} Rank={item.rank}>{item.email}</S.itemName>
              <S.itemTime isHintOn={isHintOn} Rank={item.rank}>{item.time}</S.itemTime>
            </S.RankItem>
          </S.RankFrame>
        )
      }
    })
    return (rankingListWithoutHint);
  }
}

const LeaderBoard = ():JSX.Element => {
  const member = useContext(MemberContext);
  const [rankList, setRankList] = useState([]);
  const [haveRank, setHaveRank] = useState(true);
  const [isHintOn, setHint] = useState(false);
  const [hintType, setHintType] = useState('hintOff');
  const [currentTab, setCurrentTab] = useState('Hint Off');
  const tabList = ['Hint Off', 'Hint On'];
  const [tabLine, tabLineStyle] = useTabLine(tabList, currentTab);
  const [isUserComplete, setUserComplete] = useState(true);
  const id = useParamsId();
  const [isFetchingRank, setFetchingRank] = useState(false);

  useEffect(() => {
    let mount = true;
    setFetchingRank(true);
    setHaveRank(true);
    setRankList([]);
    const getRankPayload = {
      'hintType': hintType
    }
    getChallengeRank(id, getRankPayload)
      .then((result: any) => {
        if (mount === true) {
          const challengeRankResult = result.data;
          setFetchingRank(false);
          if (challengeRankResult.length == 0) {
            setHaveRank(false);
          }
          setRankList(challengeRankResult);
        }
      })
      .catch((err) => {
        setRankList([]);
        setHaveRank(false);
        setFetchingRank(false);
        console.log(err);
      });
    return () => { mount = false };
  }, [isHintOn]);

  const handleHintOn = (key: boolean) => {
    switch (key) {
      case true:
        setCurrentTab('Hint On');
        setHintType('hintOn');
        setHint(true);
        break
      case false:
        setCurrentTab('Hint Off');
        setHintType('hintOff');
        setHint(false)
        break
    }
  }

  return (
    <S.LeaderBoard>
      <PersonalRankBoard member={member} rankList={rankList} isUserComplete={isUserComplete}></PersonalRankBoard>
      <S.Title>
        <FormattedMessage id="E032" />
        <LeaderBoardNotion />
      </S.Title>
      <S.ButtonFrame>
        <S.Tab
          isHintOn={isHintOn}
          onClick={() => handleHintOn(false)}
        >
          <FormattedMessage id="E031"/>
        </S.Tab>
        <S.Tab
          isHintOn={!isHintOn}
          onClick={() => handleHintOn(true)}
        >
          <FormattedMessage id="E030"/>
        </S.Tab>
        <S.TabLine ref={tabLine} style={tabLineStyle}/>
      </S.ButtonFrame>
      <S.Bulletin>
        <S.AttFrame>
          <S.Rank><FormattedMessage id="E033"/></S.Rank>
          <S.Name isHintOn={isHintOn}><FormattedMessage id="E034"/></S.Name>
          {isHintOn && <S.HintOpen><FormattedMessage id="E036"/></S.HintOpen>}
          <S.Time isHintOn={isHintOn}><FormattedMessage id="E035"/></S.Time>
        </S.AttFrame>
        <S.IconFrame>
          {isFetchingRank && <LoadingIcon size={10} />}
        </S.IconFrame>
        <LeaderBoardItem member={member} isHintOn={isHintOn} item={rankList}></LeaderBoardItem>
        {!haveRank && <S.NoRankMessage><FormattedMessage id="E071"/></S.NoRankMessage>}
      </S.Bulletin>
    </S.LeaderBoard>
  )
}

const PersonalRankBoard = (props: any):JSX.Element => {
  const isUserComplete = props.isUserComplete;
  const member = props.member;
  const rankList = props.rankList;
  const [personalRankTime, setPersonalRankTime] = useState('00:00:00');
  const [personalRank, setPersonalRank] = useState('#?');
  const [personalRankHint, setPersonalRankHint] = useState('0');

  useEffect(() => {
    rankList.map((item: any) => {
      if (member.id == item.userId) {
        setPersonalRankTime(item.time);
        setPersonalRank('#'+item.rank);
        setPersonalRankHint(item.hintOpen);
      }
    })
    return;
  }, [rankList]);

  if (isUserComplete)
    return (
      <S.PersonalRankBoard>
        <S.PersonalRankBoardTitle>
          <S.TimeTitle><FormattedMessage id="E035"/></S.TimeTitle>
          <S.RankTitle><FormattedMessage id="E037"/></S.RankTitle>
          <S.HintTitle><FormattedMessage id="E036"/></S.HintTitle>
        </S.PersonalRankBoardTitle>
        <S.PersonalRankBoardItem>
          <S.PersonalTime>{personalRankTime}</S.PersonalTime>
          <S.PersonalRank>{personalRank}</S.PersonalRank>
          <S.PersonalHint>{personalRankHint}</S.PersonalHint>
        </S.PersonalRankBoardItem>
      </S.PersonalRankBoard>
    )
  return (
    <></>
  )
}

export default LeaderBoard;
